export default __webpack_public_path__ + "static/media/disconnectShopify3.0b7ab965.svg";